import { Button as MuiButton } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";
import React, { forwardRef } from "react";

interface Params {
  value: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const Button = styled(MuiButton)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  margin: "0 10px",

  "&:hover": {
    backgroundColor: lighten(theme.palette.secondary.light, 0.75),
  },
}));

export const CustomButton = forwardRef<HTMLButtonElement, Params>(({ value, onClick }, ref) => (
  <Button
    variant="contained"
    onClick={onClick}
    ref={ref}
    style={{ margin: 0 }}
  >
    {value}
  </Button>
));

CustomButton.displayName = "CustomButton";
